import { FunctionComponent, ReactNode } from "react";
import { cva, VariantProps } from "class-variance-authority";

const styles = cva("px-2 py-[0.2rem] rounded-sm text-sm font-semibold", {
  variants: {
    colorVariant: {
      default: ["bg-gray-100 text-gray-800"],
      success: ["bg-green-100 text-green-800"],
      warning: ["bg-yellow-100 text-yellow-800"],
      error: ["bg-red-100 text-red-800"],
    },
  },
  defaultVariants: {
    colorVariant: "default",
  },
});
export interface BadgeProps extends VariantProps<typeof styles> {
  className?: string;
  children: ReactNode;
}

/**
 *
 */
export const Badge: FunctionComponent<BadgeProps> = ({
  className,
  colorVariant,
  children,
}) => {
  return (
    <span className={styles({ className, colorVariant })}>{children}</span>
  );
};
